import {createCookie} from './cookie.js';

(function( $ ) {
  $('input[type="submit"]').each(function(){
    let text = $(this).val();
    let button = '<button class="button hollow wpcf7-submit">'+ text +'</button>';
    $(this).after(button);
    $(this).remove();
  });

  // $('.button').each(function() {
  //   let text = $(this).text();
  //   $(this).html('<span>'+ text +'</span>');
  // });

  // pretty checkboxes

  $('input[type="checkbox"]').each(function(){
    if ($(this).parent().hasClass('pretty')) return false;
    $(this).parent().addClass('pretty p-default p-smooth')
    $(this).after('<div class="state"><label></label></div>')
  });

  $( document ).on( 'nfFormReady' , function() {
    // add artists to select field
    let artists = $('body').data('artists');

    jQuery.each(artists, function(i, val) {
      $('.nf-form-content .artist_select').append('<option value="'+ val +'">'+ val +'</option>');
    });

    if ($('body').hasClass('single-artists')) {
      // // choose actual artist
      // $('.artist_select').val($('body').data('artist'));

      // // select email of contact person
      // let email;
      // $('.contact-info .persons').each(function(){
      //   email =+ $(this).find('a.mail').text() + ', ';
      // });
      // email = email.slice(0, -2);
      // $('.email-container input').val(email);
    }
  });
})(jQuery);


// WEBPACK FOOTER //
// ./resources/assets/js/partial/forms.js